import useImgSet from "../../hooks/useImgSet";

import s from "./withLayoutOptions.module.scss";

function withLayoutOptions(Wrapped) {
  const getImgSet = useImgSet();

  function WithLayout(props) {
    const sun = getImgSet("sun", "png", s.sun);
    const clouds = getImgSet("clouds", "png", s.clouds);
    const houseSmall = getImgSet("house__small", "png", s.house__small);
    const roadClose = getImgSet("road__close", "png", s.road__close);
    const logoFooter = getImgSet("logo__footer");

    return (
      <div className={s.root}>
        <div className={s.back}>
          <div className={s.sky} />
        </div>
        <div className={s.inner}>
          {sun}
          {clouds}
          {houseSmall}
          {roadClose}

          <Wrapped {...props} />
        </div>
        <div className={s.footer}>{logoFooter}</div>
      </div>
    );
  }

  WithLayout.displayName = `WithLayoutOptions-(${Wrapped.name})`;

  return WithLayout;
}

export default withLayoutOptions;
